import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Table } from 'reactstrap';
import { string, array } from 'prop-types';
import OfferStatsTableItem from './OfferStatsTableItem';
import { currencyToSign } from '../../utils/utils';

const compareStats = (prev, curr) => {
  if (prev === 'NEW' || curr === 'NEW') {
    return null;
  } else {
    let fixedPrev = prev;
    let fixedCurr = curr;
    if (prev === '—') {
      fixedPrev = 0;
    }
    if (curr === '—') {
      fixedCurr = 0;
    }
    return fixedPrev < fixedCurr ? 'up' : fixedPrev === fixedCurr ? null : 'down';
  }
};

const prepareStats = (statistics = []) => {
  const prepared = [];

  for (let i = statistics.length - 1; i >= 0; i--) {
    const data = statistics[i];
    const { period, cr, epc, new: isNew, rate } = data;
    const stat = {
      period,
      cr: {
        value: isNew ? 'NEW' : cr === 0 ? '—' : cr,
        status: null,
      },
      epc: {
        value: isNew ? 'NEW' : epc === 0 ? '—' : epc,
        status: null,
      },
    };

    if (period === 'today') {
      const yesterday = prepared.find(({ period }) => period === 'yesterday');

      if (yesterday) {
        stat.cr.status = compareStats(yesterday.cr.value, stat.cr.value);
        stat.epc.status = compareStats(yesterday.epc.value, stat.epc.value);
      }
    }

    prepared.unshift(stat);
  }

  return prepared;
};

class OfferStatsTable extends PureComponent {
  static propTypes = {
    statistics: array.isRequired,
    currency: string.isRequired,
  };

  static defaultProps = {
    statistics: [],
  };

  render() {
    const { statistics, currency } = this.props;

    return (
      <div className="offer-stats-table-wrapper">
        <Table className="offer-stats-table" bordered>
          <thead>
            <tr>
              <th>
                <FormattedMessage id="offer.conversions.period" defaultMessage="Period" />
              </th>
              <th className="values">CR, %</th>
              <th className="values">EPC, {currencyToSign(currency)}</th>
            </tr>
          </thead>
          <tbody>
            {prepareStats(statistics).map((statElem) => (
              <OfferStatsTableItem key={statElem.period} {...statElem} />
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default OfferStatsTable;
